'use es6';

import http from 'hub-http/clients/apiClient';
export const BASE_URL = 'crm-permissions/v1/object-access-control/permissions/PIPELINES';
export const fetchPipelinePermissions = objectTypeId => http.post(`${BASE_URL}/${encodeURIComponent(objectTypeId)}/read-all`, {}).then(response => response.permissionsByObjectTypeIdAndTargetIdentifier[objectTypeId] || {});